import { useState, useEffect } from "react";

export function useAuthUser() {
  const getStoredUser = () => {
    try {
      const storedUser = localStorage.getItem("tokenuser");
      if (storedUser) return JSON.parse(storedUser);

      const admin = localStorage.getItem("admin");
      if (admin) return JSON.parse(admin);

      return null;
    } catch {
      return null;
    }
  };

  const [user, setUser] = useState(getStoredUser);

  useEffect(() => {
    const handleAuthChange = () => {
      setUser(getStoredUser());
    };

    // Listen for custom "Login" / "Logout" events
    window.addEventListener("authChange", handleAuthChange);

    return () => {
      window.removeEventListener("authChange", handleAuthChange);
    };
  }, []);

  return user;
}
